import(/* webpackMode: "eager", webpackExports: ["MainLoader"] */ "/home/runner/actions-runner/_work/cocreation-front/cocreation-front/app/components/Loader.tsx");
